import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { ReviewsTab } from './Tabs/ReviewsTab';
import { JobsTab } from './Tabs/JobsTab';
import { AuditionsTab } from './Tabs/AuditionsTab';
import { ICompanyDetails } from '../../redux/company/types';
import { COMPANY_BRAND_ORANGE } from '../../constants/companyBrand';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface ICompanyTabs {
    companyDetails?: ICompanyDetails;
}

const tabLabels = ['Reviews', 'Career', 'Jobs'];

const CompanyTabs: React.FC<ICompanyTabs> = ({ companyDetails }) => {
    const [value, setValue] = useState(tabLabels[0]);

    return (
        <Box sx={{ mt: 1 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: { xs: 3, sm: 6 },
                    borderBottom: '1px solid rgba(255,255,255,0.06)',
                    mb: 3,
                }}>
                {tabLabels.map(label => {
                    const active = value === label;
                    return (
                        <Button
                            key={label}
                            disableRipple
                            onClick={() => setValue(label)}
                            sx={{
                                pb: 2,
                                pt: 0,
                                px: 0,
                                minWidth: 'auto',
                                borderRadius: 0,
                                fontFamily: FONT_ENUM.MAIN_BOLD,
                                fontSize: '1.125rem',
                                fontWeight: 700,
                                textTransform: 'none',
                                color: active ? COMPANY_BRAND_ORANGE : 'rgba(255,255,255,0.45)',
                                borderBottom: active ? `2px solid ${COMPANY_BRAND_ORANGE}` : '2px solid transparent',
                                mb: '-1px',
                                '&:hover': {
                                    bgcolor: 'transparent',
                                    color: active ? COMPANY_BRAND_ORANGE : '#ffffff',
                                },
                            }}>
                            {label}
                        </Button>
                    );
                })}
            </Box>

            <Box sx={{ pb: 2 }}>
                {value === 'Reviews' && <ReviewsTab companyDetails={companyDetails} />}
                {value === 'Career' && <JobsTab companyDetails={companyDetails} />}
                {value === 'Jobs' && <AuditionsTab companyDetails={companyDetails} />}
            </Box>
        </Box>
    );
};

export { CompanyTabs };
